/***
 * Created on 2024/2/21
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {apiGet, apiPost} from "../../../../../service/api";
import {useTranslation} from "react-i18next";
import {useOnChange} from "../../../../../hook/form";
import {getErrorMessage} from 'common/ServiceCommon';
import {useCaptcha} from "../../../../../hook/captcha";


function ShowQnapAuthAppTotpQrcode({dispatch, state, modalRef}) {
    const { t } = useTranslation();
    const [errorMessage, setErrorMessage] = useState();
    const {onChange, values, setValues} = useOnChange({
        code: '',
        setDefault: true
    });
    const {Captcha, hasCaptcha, captchaValue, captchaError} = useCaptcha(onChange);
    const queryClient = useQueryClient();

    const initAuthApp = useQuery({
        queryKey: ['init_authenticator_secret'],
        queryFn: async () => await apiGet(`/ajax/init_google_secret_key`)
    });

    const updateTwoStepMutation = useMutation({
        mutationFn: async (data) => await apiPost(`/ajax/two_step`, data),
        onSuccess: data => {
            dispatch({type: 'toggleShowSuccess', value: true, device: data?.device});
        },
        onError: (error, variables, context) => {
            // const message = error?.cause ? error.cause?.message : error.toString();
            // modalRef.current.alert('error', true, message);
            console.error(error);
            queryClient.invalidateQueries({
                queryKey: ['get_captcha_image']
            })
            setErrorMessage(getErrorMessage(t, error.cause?.code));
        }
    });

    const onVerify = async (e) => {
        const data = {
            ...values,
            verify_type: 'google_auth'
        };
        await updateTwoStepMutation.mutateAsync(data);
    }

    return (
        <div className="two-step--verify">
            <div className="two-step--verify__qrcode">
                <img src={initAuthApp.isFetching ? '' : initAuthApp?.data?.qrcode} alt="" />
            </div>
            <div className="two-step--verify__action">
                <p>{t('@Scan the QR code using your authenticator app, or enter the key manually@')}</p>
                <p className="two-step--verify__action__code !mb-0">{initAuthApp?.data?.secret}</p>
                <div className="divider"></div>
                <p>{t('@Enter the six digit code@')}</p>
                <div className="two-step--verify__action__form">
                    <input type="text"
                           name="code"
                           maxLength={6}
                           pattern="\d*"
                           onChange={onChange}
                           value={values.code}/>
                    <button className="q-btn q-btn--default btn-rounded-full" disabled={values.code?.length !== 6}
                            onClick={onVerify}>{t('@Verify@')}</button>

                </div>

                {errorMessage && <p className="text-error">{errorMessage}</p>}

                {hasCaptcha && Captcha}

                <div className="comp-checkbox mt-24">
                    <label className="q-checkbox">
                        <input type="checkbox" name="setDefault"
                               value={values.setDefault}
                               checked={values.setDefault}
                               onChange={e => setValues(prev => ({...prev, setDefault: !prev.setDefault}))}/>
                        {t('@Set as default authentication method@')}
                    </label>
                </div>
            </div>
        </div>
    );
}

export default ShowQnapAuthAppTotpQrcode;